import React,{FC}from 'react'
import { Grid, Typography, Button } from '@mui/material'
interface Props{
    errorMessage?:string;
    setLoading?:any;
    setError?:any;
}

const Errorview:FC<Props>=({errorMessage,setLoading,setError})=> {
    return(
        <Grid sx={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%",height:"45vh",}}>
            <Grid>
                <Grid sx={{display:"flex",justifyContent:"center"}}>
                    <Typography variant="body2" sx={{fontSize:"80px",textAlign:'center',color:"red !important"}}>OOPS!</Typography>
                </Grid> 
                
                <Grid sx={{display:"flex",justifyContent:"center"}}>
                    <Typography variant="body2" sx={{fontSize:"20px",textAlign:'center'}}>Something went wrong</Typography>
                </Grid>
                
                <Grid sx={{display:"flex",justifyContent:"center",marginTop:"10px"}}>
                    <Typography variant="body2" sx={{fontSize:"17px",textAlign:'center'}}>{errorMessage}</Typography>
                </Grid>
                
                <Grid sx={{display:"flex",justifyContent:"center",marginTop:"10px"}}>
                    <Button variant="outlined" onClick={()=>{setError(null); setLoading(false)}}>Please Try Again</Button>
                </Grid>
            </Grid>
        </Grid>
      )
}

export default Errorview